module.exports = __webpack_public_path__ + "static/notes-1a3201b84e8f33693c4ad46a2a80740b.svg";